// extracted by mini-css-extract-plugin
export default {"flexClass":"UsersSkeleton_flexClass__F9R-Z","title":"UsersSkeleton_title__AAs4K","filter":"UsersSkeleton_filter__7jfpz","cardContainer":"UsersSkeleton_cardContainer__y-YvB"};